module.exports = __webpack_public_path__ + "img/top_safe03.c3ae8c78.png";